import React from 'react';
import history from 'app/routes/history';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';
import Button from 'app/components/general/Button';
import ManageTeamMembers from 'app/features/manage-team/components/ManageTeamMembers';
import ManageTeamPayments from 'app/features/manage-team/components/ManageTeamPayments';
import ManageTeamNotifications from 'app/features/manage-team/components/ManageTeamNotifications';

import * as teamActions from 'app/ducks/teams/actions';
import * as teamMemberActions from 'app/ducks/teamMembers/actions';
import * as paymentActions from 'app/ducks/payments/actions';
import * as paymentCollectionActions from 'app/ducks/paymentCollections/actions';
import * as reminderActions from 'app/ducks/reminders/actions';

import * as teamSelectors from 'app/ducks/teams/selectors';
import * as teamMemberSelectors from 'app/ducks/teamMembers/selectors';
import * as paymentSelectors from 'app/ducks/payments/selectors';
import * as paymentCollectionSelectors from 'app/ducks/paymentCollections/selectors';
import * as reminderSelectors from 'app/ducks/reminders/selectors';
import * as userSelectors from 'app/ducks/users/selectors';

function selector(state) {
  return {
    teams: {
      ...teamSelectors.getTeams(state),
      getPaymentIds: (teamId) => teamSelectors.getPaymentIds(state, teamId),
      getTeamMemberIds: (teamId) => teamSelectors.getTeamMemberIds(state, teamId),
      getCurrentTeam: () => teamSelectors.getCurrentTeam(state),
    },
    teamMembers: teamMemberSelectors.getTeamMembers(state),
    payments: paymentSelectors.getPayments(state),
    paymentCollections: paymentCollectionSelectors.getPaymentCollections(state),
    currentUser: userSelectors.getCurrentFormUser(state),
    reminders: reminderSelectors.getReminders(state),
  };
}

const actionCreators = _.merge(
  teamActions,
  teamMemberActions,
  paymentActions,
  paymentCollectionActions,
  reminderActions,
);

interface IManageTeamLayoutProps {
  actions: any;
  teamMembers: any;
  payments: any;
  teams: any;
  currentUser: any;
  paymentCollections: any;
  reminders: any;
  match: any;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class ManageTeamLayout extends React.Component<
  IManageTeamLayoutProps
> {
  static defaultProps: IManageTeamLayoutProps = {
    actions: undefined,
    teamMembers: undefined,
    payments: undefined,
    teams: undefined,
    currentUser: undefined,
    paymentCollections: undefined,
    reminders: undefined,
    match: undefined,
  };

  render(): React.ReactNode {
    return (
      <RenderContent className="manage-team-app" match={this.props.match}>
        <div className="row">
          <div className="col">
            <HeaderThin title="Manage Team" divider>
              <div className="col col-5 col-md-4 col-lg-3 header-thin-children">
                <Button
                  className="btn-2 btn-thin"
                  onClick={() => history.push(`/teams/detail/${this.props.teams.currentTeam.id}`)}
                >
                  Edit Team
                </Button>
              </div>

            </HeaderThin>
          </div>
        </div>
        <ManageTeamNotifications
          actions={this.props.actions}
          currentTeam={this.props.teams.currentTeam}
        />
        <div className="row">
          <div className="col">
            <ManageTeamMembers
              currentUser={this.props.currentUser}
              actions={this.props.actions}
              isLoading={this.props.teamMembers.isLoading}
              currentTeam={this.props.teams.currentTeam}
              errors={this.props.teamMembers.backendErrors}
              teamMembersById={this.props.teamMembers.teamMembersById}
              teamMemberIds={this.props.teams.currentTeam.teamMembers}
            />
          </div>
        </div>
        <div className="row with-margin-top">
          <div className="col">
            <ManageTeamPayments
              actions={this.props.actions}
              isLoading={this.props.payments.isLoading}
              hasLoaded={this.props.payments.loaded}
              paymentsById={this.props.payments.paymentsById}
              paymentIds={paymentSelectors.getPaymentIdsByTeamId(
                this.props.payments.paymentsById,
                this.props.teams.currentTeamId,
              )}
              paymentCollectionsById={
                this.props.paymentCollections.paymentCollectionsById
              }
              reminders={this.props.reminders}
            />
          </div>
        </div>
      </RenderContent>
    );
  }
}
